import React, { useState, useEffect } from "react";
import "../Styles/Post.css"; // Import CSS styles
import UPMediaRemover from "../Utils/UPMediaRemover"
import POProfileImageUploader from "../Utils/ProfileImageUploader";
import { color } from "framer-motion";

const CreatePost = ({userId, profileId}) => {  
  const [description, setDescription] = useState("");
  const [selectedMedia, setSelectedMedia] = useState([]);
  const [uploadedMedia, setUploadedMedia] = useState([]);
  const [showRemovePopup, setShowRemovePopup] = useState(false);
  const [mediaToRemove, setMediaToRemove] = useState([]);
  const [postMedia, setPostMedia] = useState([]);
  const [visibility, setVisibility] = useState(false);

  // Load from localStorage on mount
  useEffect(() => {
    const storedMedia = JSON.parse(localStorage.getItem('uploadedMedia')) || [];
    setUploadedMedia(storedMedia);
  }, []);

  // Update localStorage whenever uploadedMedia changes
  useEffect(() => {
    localStorage.setItem('uploadedMedia', JSON.stringify(uploadedMedia));
  }, [uploadedMedia]);

  // Handle media file selection
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const relativePaths = files.map((file) => ({
      name: file.name,
      path: `media/${file.name}` // Simulate relative path
    }));
    setSelectedMedia(relativePaths);
  };

  const toggleVisibility = () => {
    setVisibility(prev => !prev);
  };

  // Function to check if any media is uploaded
  const hasMedia = uploadedMedia.length > 0;

  // Handle media upload
  const handleUpload = () => {
    if (selectedMedia.length === 0) {
      alert("No media selected!");
      return;
    }
    setUploadedMedia((prev) => [...prev, ...selectedMedia]); // Append new media
    setSelectedMedia([]); // Clear selection after upload
  };

  // Handle post submission
  const handlePost = () => {
    if (!description && uploadedMedia.length === 0) {
      alert("Please enter a description or upload media!");
      return;
    }
  
    const postData = {
      description,
      media: uploadedMedia.map((file) => file.name), // Simulated media paths
    };
  
    setPostMedia((prev) => [...prev, postData]); // ✅ Correct usage
    // Reset form
    setDescription("");
    setUploadedMedia([]);
  };

  // Handle remove popup
  const handleRemoveClick = () => {
    setMediaToRemove([]);
    setShowRemovePopup(true);
  };

  // Remove selected media
  const handleRemoveSelected = () => {
    const updated = uploadedMedia.filter(
      (file) => !mediaToRemove.includes(file.path)
    );
    setUploadedMedia(updated);
    setShowRemovePopup(false);
  };

  // Toggle checkbox in popup
  const toggleMediaSelect = (path) => {
    setMediaToRemove((prev) =>
      prev.includes(path) ? prev.filter((p) => p !== path) : [...prev, path]
    );
  };

  // Handle media removal
const handleRemoveMedia = (index) => {
  console.log("handle remove media being called")
  setUploadedMedia((prev) => prev.filter((_, i) => i !== index));
};
  
  return (
        <div className="up-grid-layout">
          <div className="up-post-main-grid">
          <div className="up-header-container" style={{background: "none"}}>
            <POProfileImageUploader
                    userId={userId}
                    profileImage={null}
                    profileName={profileId}
                    operationType="post"
                />
          </div>
          <div className="up-post-container" style={{background: "none"}}>
          <div className="up-create-post-container">      
              {/* Description Input */}
              <textarea
                className="up-description-input"
                placeholder="Write something..."
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                rows={4}
              />

              <div className="up-submission-container">
                {/* Media Upload Section */ }
                <div className="up-media-section" >
                  <div style={{display: "flex", flexDirection: "row"}}>
                  <input type="file" 
                    multiple accept="image/*,video/*" 
                    onChange={handleFileChange} 
                    style={{width: 200}}/>
                    <button className="up-upload-btn" onClick={handleUpload}>Upload</button>
                </div>
              <div>
              
              {/* remove uploaded post. */}
              <button className="up-remove-btn" onClick={handleRemoveClick}
              disabled={uploadedMedia.length === 0}
              >Remove</button>
              
              {/* Media remove popup */}
              {showRemovePopup && (
              <div style={popupStyle}>
                <h4>Select media to remove</h4>
                <ul>
                  {uploadedMedia.map((file, index) => (
                    <li key={index}>
                      <label>
                      <input
                        type="checkbox"
                        checked={mediaToRemove.includes(file.path)}
                        onChange={() => toggleMediaSelect(file.path)}
                      />{' '}
                        {file.path}
                      </label>
                    </li>
                  ))}
                </ul>
                <button onClick={handleRemoveSelected} style={{background: "rgb(34, 31, 31)"}}>Remove</button>
                <button onClick={() => setShowRemovePopup(false)}
                  style={{background: "rgb(34, 31, 31)", marginLeft: 50}}
                  >Cancel</button>
              </div>
            )}
            </div>
              <div>
                {/* Post Button */}
                <button className="up-post-btn" onClick={handlePost}
                >Post</button>
              </div>
            </div>          
              {/* Display Uploaded Media */}
              <div className="up-uploaded-media">
                {uploadedMedia.map((file, index) => (
                  <span key={index} className="up-media-preview">{file.name}</span>
                ))}
              </div>
            </div>
            </div>
            <div style={{ marginLeft: 40, marginTop: 10, display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontWeight: 600 }}>Visibility:</span>
                <label className="up-toggle-switch">
                  <input type="checkbox" checked={visibility} onChange={toggleVisibility} />
                  <span className="up-toggle-slider" />
                </label>
                <span style={{ color: visibility ? "green" : "red", fontWeight: "bold" }}>
                  {visibility ? "Public" : "Private"}
              </span>
            </div>

            </div>
            <div className="up-post-lower-segment" style={{marginTop: 10}}>
              {postMedia.map((post, index) => (
              <div key={index} className="up-post-item" style={{ marginBottom: 20, padding: 10 }}>
      
              {/* Post Header (Description) */}
              <div className="up-post-header-segment" style={{ padding: 8 }}>
                <strong>Description:</strong> {post.description}
                </div>

                {/* Media Section */}
                <div className="up-post-feed-segment" style={{ padding: 8, marginTop: 5, display: "flex", gap: 10, flexWrap: "wrap" }}>
                  {post.media.map((path, i) => (
                  <img
                    key={i}
                    src={path}
                    alt={`media-${i}`}
                    style={{
                      width: 100,
                      height: 100,
                      objectFit: "cover",
                      borderRadius: 8,
                      border: "2px solid #eee"
                    }}
                  />
                ))}
                </div>
              </div>
            ))}
          </div>
        </div> 
      </div>
    );
};

const popupStyle = {
  position: 'fixed',
  top: '55%',
  left: '78%',
  transform: 'translate(-50%, -30%)',
  backgroundColor: 'black',
  color: 'white',
  padding: '1rem',
  border: '1px solid #ccc',
  borderRadius: '8px',
  zIndex: 1000,
  boxShadow: '0 0 10px rgba(0,0,0,0.2)'
};

export default CreatePost;